<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Gabinety</span>
        <h3 class="page-title">Lista gabinetów</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success"
                  @click.prevent="$router.push('/gabinety/dodaj')">
          <i class="material-icons">add</i>
          Dodaj gabinet
        </d-button>
      </d-col>
    </d-row>

    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="users-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę gabinetu"
          v-model="filters.search" />
        <v-select
          style="width: 360px;"
          class="ml-2"
          :options="institutions"
          :reduce="institution => institution.id"
          v-model="filters.institution_id"
          placeholder="Lista placówek"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Nazwa</th>
          <th scope="col" class="border-0">Placówka</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(office, index) of offices"
          :key="'user-' + index">
          <td class="align-middle">
            {{ office.name }}
          </td>
          <td class="align-middle">
            {{ office.institution ? office.institution.name : '' }}
          </td>
          <td
            class="align-middle"
            style="width: 150px;">
            <d-button
              theme="primary"
              @click.prevent="$router.push('/gabinety/edycja/' + office.id)"
              class="mr-2"
              title="Edytuj">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeOffice(office.id)"
              title="Usuń">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="offices.length === 0">
          <td
            colspan="5"
            class="text-center">
            Brak gabinetów do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import FormUtils from './../utils/FormUtils.js';

export default {
  name: 'offices',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      institutions: [],
      offices: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: '',
        institution_id: '',
      }
    };
  },
  mounted () {
    this.loadFilteredData();
    this.loadInstitutionsListData();
  },
  methods: {
    loadInstitutionsListData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'institutions/items',
        outputKey: 'institutions',
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search,
      };
      if (this.filters.institution_id !== null && this.filters.institution_id) {
        where.institution_id = this.filters.institution_id;
      }
      ListUtils.loadItemsData(this, {
        endpoint: '/offices/items?page=' + this.currentPage,
        listField: 'offices',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        institution: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      return this.debouncedLoadFilteredData
    },
    removeOffice (officesID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/offices/delete/',
        id: officesID,
        successTitle: 'Usunięto gabinet',
        successText: 'Wybrany gabinet został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten gabinet?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie gabinetu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

